module.exports = __webpack_public_path__ + "img/popov2.f0661171.jpg";